
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebe40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebe40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gYMat", function(module, exports) {

$parcel$export(module.exports, "register", () => $c5c79d140c56a49c$export$6503ec6e8aabbaf, (v) => $c5c79d140c56a49c$export$6503ec6e8aabbaf = v);
var $c5c79d140c56a49c$export$6503ec6e8aabbaf;
var $c5c79d140c56a49c$export$f7ad0328861e2f03;
"use strict";
var $c5c79d140c56a49c$var$mapping = new Map();
function $c5c79d140c56a49c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c5c79d140c56a49c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c5c79d140c56a49c$var$resolve(id) {
    var resolved = $c5c79d140c56a49c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c5c79d140c56a49c$export$6503ec6e8aabbaf = $c5c79d140c56a49c$var$register;
$c5c79d140c56a49c$export$f7ad0328861e2f03 = $c5c79d140c56a49c$var$resolve;

});

var $bdb1753a4bbea108$exports = {};

(parcelRequire("gYMat")).register(new URL("", import.meta.url).toString(), JSON.parse('["h00hi","index.15b71b8c.js","7FSpK","metacamp-logo.afc6991f.png"]'));


//# sourceMappingURL=index.runtime.eb5cbe09.js.map
